import React from "react";
import {
  makeStyles,
  Box,
  Typography,
  Button,
  Container,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import oficina from "../images/CodigoQR.jpeg";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

const useStyles = makeStyles((theme) => ({
  // Aplicamos Paralucent globalmente para todo el body
  "@global": {
    body: {
      fontFamily: "Paralucent, sans-serif",
    },
  },
  container: {
    backgroundColor: "#000", // Fondo negro
    color: "#fff",           // Texto blanco
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    padding: theme.spacing(2),
  },
  root: {
    display: "flex",
    alignItems: "center",
    // En pantallas pequeñas, apilamos verticalmente
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  imageContainer: {
    width: "60%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginBottom: theme.spacing(2),
    },
  },
  image: {
    width: "100%",
    height: "auto",
    display: "block",
  },
  textContainer: {
    width: "40%",
    marginLeft: 20, // Separación entre columnas
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginLeft: 0,
    },
  },
  heading: {
    marginBottom: theme.spacing(2),
    fontWeight: "bold",
  },
  paragraph: {
    textAlign: "justify",
    textJustify: "inter-word",
    lineHeight: "1.6",
    width: "100%",
    display: "block",
    wordSpacing: "0.1em",
    fontSize: 15,
  },
  listText: {
    fontSize: "1.5rem",
    lineHeight: 1.5,
  },
  pillTitle: {
    display: "inline-block",
    padding: "8px 16px",
    fontSize: "1.5rem",
    borderRadius: "9999px",
    backgroundColor: "#fff", // Fondo blanco
    color: "#000",           // Texto negro
    fontWeight: "bold",
    marginBottom: theme.spacing(3),
  },
  button: {
    backgroundColor: "#fff",
    color: "#000",
    marginTop: theme.spacing(4),
    "&:hover": {
      backgroundColor: "#ccc", // Efecto hover
    },
  },
  buttonLarge: {
    fontSize: "1.5rem", // Aumenta el tamaño de letra
    padding: theme.spacing(1, 3),
    [theme.breakpoints.up("sm")]: {
      fontSize: "1rem",
    },
  },
}));

const Quienes = () => {
  const classes = useStyles();

  return (
    <Container maxWidth="lg" className={classes.container}>
      <Box className={classes.root}>
        {/* Columna Izquierda: Imagen (60%) */}
        <Box className={classes.imageContainer}>
          <img
            src={oficina} // Asegúrate de que la ruta a la imagen es correcta
            alt="Oficina"
            className={classes.image}
          />
        </Box>

        {/* Columna Derecha: Texto (40%) */}
        <Box className={classes.textContainer}>
          <Typography variant="h6" className={classes.pillTitle}>
            ¿Por qué elegirnos?
          </Typography>

          <Typography variant="2" className={classes.paragraph}>
            En Q2, transformamos la gestión de eventos con tecnología que marca la diferencia. Nuestro sistema de acreditaciones está diseñado para agilizar procesos, ofrecer datos en tiempo real y garantizar la seguridad de tus asistentes. Nos destacamos por:
          </Typography>

          <Typography component="div" variant="body1" className={classes.paragraph}>
            <List disablePadding>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon style={{ color: "white" }} />
                </ListItemIcon>
                <ListItemText
                  primaryTypographyProps={{ className: classes.listText }}
                  primary="Eﬁciencia comprobada: Simpliﬁcamos el registro y acceso de participantes, reduciendo tiempos de espera."
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon style={{ color: "white" }} />
                </ListItemIcon>
                <ListItemText
                  primaryTypographyProps={{ className: classes.listText }}
                  primary="Tecnología avanzada: Utilizamos códigos QR, sistemas RFID y software adaptable para una experiencia moderna."
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon style={{ color: "white" }} />
                </ListItemIcon>
                <ListItemText
                  primaryTypographyProps={{ className: classes.listText }}
                  primary="Personalización total: Ajustamos nuestras soluciones a las necesidades específicas de cada evento."
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon style={{ color: "white" }} />
                </ListItemIcon>
                <ListItemText
                  primaryTypographyProps={{ className: classes.listText }}
                  primary="Monitoreo en tiempo real: Accede a métricas actualizadas que optimizan la toma de decisiones.."
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon style={{ color: "white" }} />
                </ListItemIcon>
                <ListItemText
                  primaryTypographyProps={{ className: classes.listText }}
                  primary="Soporte continuo: Un equipo especializado que te acompaña en cada paso del proceso."
                />
              </ListItem>
            </List>
          </Typography>

          {/* Botón opcional (comentado) */}
          {/* <Link to="/propiedades" style={{ textDecoration: "none" }}>
            <Button variant="contained" className={classes.buttonLarge}>
              Encontrá tu Propiedad
            </Button>
          </Link> */}
        </Box>
      </Box>
    </Container>
  );
};

export default Quienes;
